import { render, staticRenderFns } from "./LoyaltyDropdownV2.vue?vue&type=template&id=2410e4a0&scoped=true"
import script from "./LoyaltyDropdownV2.vue?vue&type=script&lang=js"
export * from "./LoyaltyDropdownV2.vue?vue&type=script&lang=js"
import style0 from "./LoyaltyDropdownV2.vue?vue&type=style&index=0&id=2410e4a0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2410e4a0",
  null
  
)

export default component.exports